module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.43562f54.mp3";